import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';

export interface LoadViewDialogData {
  savedViews: any[];
  entityType: string;
}

@Component({
  selector: 'app-load-view-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatListModule,
    MatIconModule
  ],
  template: `
    <h2 mat-dialog-title>Load Saved View</h2>
    <mat-dialog-content>
      @if (data.savedViews && data.savedViews.length > 0) {
        <mat-list>
          @for (view of data.savedViews; track view.name) {
            <mat-list-item>
              <button mat-button (click)="selectView(view)" class="view-button">
                <mat-icon>visibility</mat-icon>
                <span class="view-name">{{ view.name || 'Unnamed View' }}</span>
              </button>
            </mat-list-item>
          }
        </mat-list>
      } @else {
        <p class="no-views">No saved views found. Save a view first to load it later.</p>
      }
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="cancel()">Cancel</button>
    </mat-dialog-actions>
  `,
  styles: [`
    mat-dialog-content {
      min-width: 400px;
      max-height: 500px;
      overflow-y: auto;
    }

    .view-button {
      width: 100%;
      text-align: left;
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 8px 16px;
    }

    .view-name {
      flex: 1;
    }

    .no-views {
      padding: 24px;
      text-align: center;
      color: #666;
    }

    mat-list-item {
      border-bottom: 1px solid #e0e0e0;
    }

    mat-list-item:hover {
      background-color: #f5f5f5;
    }
  `]
})
export class LoadViewDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<LoadViewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: LoadViewDialogData
  ) {}

  selectView(view: any): void {
    this.dialogRef.close(view);
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
